/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import { DgMenuItem, UserPermissions } from './types';
import { NbMenuBag } from '@nebular/theme';


const itemClick$ = new Subject<NbMenuBag>();
const addItems$ = new ReplaySubject<{ tag: string; items: DgMenuItem[] }>(1);
const navigateHome$ = new ReplaySubject<{ tag: string }>(1);
const getSelectedItem$
  = new ReplaySubject<{ tag: string; listener: BehaviorSubject<NbMenuBag> }>(1);
const itemSelect$ = new ReplaySubject<NbMenuBag>(1);
const itemHover$ = new ReplaySubject<NbMenuBag>(1);
const submenuToggle$ = new ReplaySubject<NbMenuBag>(1);
const collapseAll$ = new ReplaySubject<{ tag: string }>(1);


// TODO: map select events to router change events
// TODO: review the interface
/**
 *
 *
 * Menu Service. Allows you to listen to menu events, or to interact with a menu.
 * @stacked-example(Menu Service, menu/menu-service.component)
 *
 *
 */
@Injectable()
export class DgMenuService {
  /**
   * Add items to the end of the menu items list
   * @param {List<NbMenuItem>} items
   * @param {string} tag
   */
  addItems(items: DgMenuItem[], tag?: string) {
    addItems$.next({ tag, items });
  }

  /**
   * Collapses all menu items
   * @param {string} tag
   */
  collapseAll(tag?: string) {
    collapseAll$.next({ tag });
  }

  /**
   * Navigate to the home menu item
   * @param {string} tag
   */
  navigateHome(tag?: string) {
    navigateHome$.next({ tag });
  }

  /**
   * Returns currently selected item. Won't subscribe to the future events.
   * @param {string} tag
   * @returns {Observable<{tag: string; item: NbMenuItem}>}
   */
  getSelectedItem(tag?: string): Observable<NbMenuBag> {
    const listener = new BehaviorSubject<NbMenuBag>(null);

    getSelectedItem$.next({ tag, listener });

    return listener.asObservable();
  }

  onItemClick(): Observable<NbMenuBag> {
    return itemClick$.pipe(share());
  }

  onItemSelect(): Observable<NbMenuBag> {
    return itemSelect$.pipe(share());
  }

  onItemHover(): Observable<NbMenuBag> {
    return itemHover$.pipe(share());
  }

  onSubmenuToggle(): Observable<NbMenuBag> {
    return submenuToggle$.pipe(share());
  }


  setPermissions(item: DgMenuItem, userPermissions: UserPermissions): void {
    if (userPermissions.all && !item.dontBeAdmin) {
      item.hidden = false;
      if(item.children?.length) item.children.forEach(child=>child.hidden=false)
    } else if (!item.permissions || !item.permissions.length) {
      item.hidden = false;
    } else if (item.permissions[0] === "*") {
      if (!item.children || !item.children.length) {
        item.hidden = false;
        return
      } else {
        item.hidden = true
      }
      for (const child of item.children) {
        if (child.permissions && child.permissions.length) {
          child.hidden = true;
          child.permissions.forEach(childPermission => {
            if (userPermissions.permissions.includes(childPermission)) {
              child.hidden = false;
              item.hidden = false;
            }
          })
        } else {
          item.hidden = false;
        }
      }
    } else {
      item.hidden = true;
      for (const permission of item.permissions) {
        if (userPermissions.permissions.includes(permission)) item.hidden = false;
      }
    }
  }

  isSelectedLink(item: DgMenuItem,url:string) {
    if (item.link) {
      item.selected = url.includes(item.link)
    } else if (item.children && item.children.length) {
      item.selected = false
      item.children.map(child => { if (url.includes(child.link)) { child.selected = true  , item.selected = true} else { child.selected = false } })
    }else{ 
      item.selected = false;
    }
  }
}

// @Injectable()
// export class NbMenuInternalService {

//   constructor(private location: Location, protected authService: AuthService) { }

//   prepareItems(items: DgMenuItem[], userPermissions: UserPermissions) {
//     const defaultItem = new DgMenuItem();
//     items.forEach(i => {
//       this.applyDefaults(i, defaultItem, userPermissions);
//       this.setParent(i);
//     });
//   }

//   selectFromUrl(items: DgMenuItem[], tag: string, collapseOther: boolean = false) {
//     const selectedItem = this.findItemByUrl(items);
//     if (selectedItem) {
//       this.selectItem(selectedItem, items, collapseOther, tag);
//     }
//   }

//   selectItem(item: DgMenuItem, items: DgMenuItem[], collapseOther: boolean = false, tag: string) {
//     const unselectedItems = this.resetSelection(items);
//     const collapsedItems = collapseOther ? this.collapseItems(items) : [];

//     for (const parent of DgMenuItem.getParents(item)) {
//       parent.selected = true;
//       // emit event only for items that weren't selected before ('unselectedItems' contains items that were selected)
//       if (!unselectedItems.includes(parent)) {
//         this.itemSelect(parent, tag);
//       }

//       const wasNotExpanded = !parent.expanded;
//       parent.expanded = true;
//       const i = collapsedItems.indexOf(parent);
//       // emit event only for items that weren't expanded before.
//       // 'collapsedItems' contains items that were expanded, so no need to emit event.
//       // in case 'collapseOther' is false, 'collapsedItems' will be empty,
//       // so also check if item isn't expanded already ('wasNotExpanded').
//       if (i === -1 && wasNotExpanded) {
//         this.submenuToggle(parent, tag);
//       } else {
//         collapsedItems.splice(i, 1);
//       }
//     }

//     item.selected = true;
//     // emit event only for items that weren't selected before ('unselectedItems' contains items that were selected)
//     if (!unselectedItems.includes(item)) {
//       this.itemSelect(item, tag);
//     }

//     // remaining items which wasn't expanded back after expanding all currently selected items
//     for (const collapsedItem of collapsedItems) {
//       this.submenuToggle(collapsedItem, tag);
//     }
//   }

//   collapseAll(items: DgMenuItem[], tag: string, except?: DgMenuItem) {
//     const collapsedItems = this.collapseItems(items, except);

//     for (const item of collapsedItems) {
//       this.submenuToggle(item, tag);
//     }
//   }

//   onAddItem(): Observable<{ tag: string; items: DgMenuItem[] }> {
//     return addItems$.pipe(share());
//   }

//   onNavigateHome(): Observable<{ tag: string }> {
//     return navigateHome$.pipe(share());
//   }

//   onCollapseAll(): Observable<{ tag: string }> {
//     return collapseAll$.pipe(share());
//   }

//   onGetSelectedItem(): Observable<{ tag: string; listener: BehaviorSubject<NbMenuBag> }> {
//     return getSelectedItem$.pipe(share());
//   }

//   itemHover(item: DgMenuItem, tag?: string) {
//     itemHover$.next({ tag, item });
//   }

//   submenuToggle(item: DgMenuItem, tag?: string) {
//     submenuToggle$.next({ tag, item });
//   }

//   itemSelect(item: DgMenuItem, tag?: string) {
//     itemSelect$.next({ tag, item });
//   }

//   itemClick(item: DgMenuItem, tag?: string) {
//     itemClick$.next({ tag, item });
//   }

//   /**
//    * Unselect all given items deeply.
//    * @param items array of items to unselect.
//    * @returns items which selected value was changed.
//    */
//   private resetSelection(items: DgMenuItem[]): DgMenuItem[] {
//     const unselectedItems = [];

//     for (const item of items) {
//       if (item.selected) {
//         unselectedItems.push(item);
//       }
//       item.selected = false;

//       if (item.children) {
//         unselectedItems.push(...this.resetSelection(item.children));
//       }
//     }

//     return unselectedItems;
//   }

//   /**
//    * Collapse all given items deeply.
//    * @param items array of items to collapse.
//    * @param except menu item which shouldn't be collapsed, also disables collapsing for parents of this item.
//    * @returns items which expanded value was changed.
//    */
//   private collapseItems(items: DgMenuItem[], except?: DgMenuItem): DgMenuItem[] {
//     const collapsedItems = [];

//     for (const item of items) {
//       if (except && (item === except || DgMenuItem.isParent(item, except))) {
//         continue;
//       }

//       if (item.expanded) {
//         collapsedItems.push(item)
//       }
//       item.expanded = false;

//       if (item.children) {
//         collapsedItems.push(...this.collapseItems(item.children));
//       }
//     }

//     return collapsedItems;
//   }



//   private applyDefaults(item, defaultItem, userPermissions) {
//     this.setPermissions(item, userPermissions)
//     const menuItem = { ...item };
//     Object.assign(item, defaultItem, menuItem);
//     item.children && item.children.forEach(child => {
//       this.applyDefaults(child, defaultItem, userPermissions);
//     });
//   }

//   private setParent(item: DgMenuItem) {
//     item.children && item.children.forEach(child => {
//       child.parent = item;
//       this.setParent(child);
//     });
//   }

//   /**
//    * Find deepest item which link matches current URL path.
//    * @param items array of items to search in.
//    * @returns found item of undefined.
//    */
//   private findItemByUrl(items: DgMenuItem[]): DgMenuItem | undefined {
//     let selectedItem;

//     items.some(item => {
//       if (item.children) {
//         selectedItem = this.findItemByUrl(item.children);
//       }
//       if (!selectedItem && this.isSelectedInUrl(item)) {
//         selectedItem = item;
//       }

//       return selectedItem;
//     });

//     return selectedItem;
//   }

//   private isSelectedInUrl(item: DgMenuItem): boolean {
//     const exact: boolean = item.pathMatch === 'full';
//     const link: string = item.link;

//     const isSelectedInPath = exact
//       ? isUrlPathEqual(this.location.path(), link)
//       : isUrlPathContain(this.location.path(), link);

//     if (isSelectedInPath && item.fragment != null) {
//       return exact
//         ? isFragmentEqual(this.location.path(true), item.fragment)
//         : isFragmentContain(this.location.path(true), item.fragment);
//     }

//     return isSelectedInPath;
//   }
// }
